import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';

import CN from './Tooltip.module.scss';

const Tooltip = ({ title = '', children, calendarMode }) => (
  <div className={cn(CN.component, CN[calendarMode])} data-bem="Tooltip">
    <span>{title}</span>
    <div className={CN.icon}>
      <span className={CN.tooltip}>{children}</span>
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

export default connect(mapStateToProps)(Tooltip);
